export const state = () => ({
  diversities: {},
  gameList: [],
  recList: [],
  page: 1,
  pageSize: 12,
  categoryId: 0,
  topicId: 0,
  styleId: 0,
  letterId: 0,
  imglistShow: true,
  searchName: ''
})

export const mutations = {
  setImglistShow(state, imglistShow) {
    state.imglistShow = imglistShow
  },
  setDiversities(state, obj) {
    state.diversities = obj
  },
  setGames(state, arr) {
    state.gameList = arr
  },
  setPage(state, page) {
    state.page = page
  },
  setRecList(state, arr) {
    state.recList = arr
  },
  setCateTopic(state, { categoryId, topicId, styleId, letterId }) {
    state.categoryId = categoryId
    state.topicId = topicId
    state.styleId = styleId
    state.letterId = letterId
    state.page = 1
    state.gameList = []
  },
  setSearchName(state, searchName) {
    state.searchName = searchName
  }
}

export const getters = {
  imglistShow({ state }) {
    return state.imglistShow
  }
}

export const actions = {
  getDiversities({ commit }) {
    return this.$request('allGameCategory').then((data) => {
      commit('setDiversities', data)
    })
  },
  getRecommend({ commit }) {
    return this.$request('allGameRec').then((data) => {
      commit('setRecList', data)
    })
  },
  getGameList({ commit, dispatch, state }, payload = {}) {
    const { pageSize, categoryId, topicId, styleId, letterId } = state
    const page = payload.page || state.page
    return this.$request('allGameList', {
      body: {
        category_id: categoryId,
        topic_id: topicId,
        combatform_id: styleId,
        initial_id: letterId,
        page,
        page_size: pageSize
      }
    }).then((data = []) => {
      commit('setGames', page === 1 ? data : [...state.gameList, ...data])
      commit('setPage', page + 1)
      if (!data.length && page === 1) {
        dispatch('getRecommend')
      }
      return data
    })
  }
}
